/**
 * @file 二维码登录布局
 * @author hanzhichen(hanzhichen@baijia.com)
 * @date 2020-12-15
 */
import PropTypes from 'prop-types';
import './index.less';

function QRLoginLayout(props) {
    const {children} = props;
    return (
        <div className="qrcode-login-layout">
            {children}
        </div>
    );
}

QRLoginLayout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default QRLoginLayout;
